import axios from "axios";
import { ISearchIdMetadata } from "pages/Explore/types";
import { QueryFunctionContext, useQuery } from "react-query";
import { DATA_URL, API_VERSION } from "utils/constants";

export const useSearchIdMetadata = (searchId: string | null) => {
  return useQuery(["searchId", searchId], getSearchIdMetadata, {
    enabled: Boolean(searchId),
  });
};

const getSearchIdMetadata = async (
  queryContext: QueryFunctionContext<["searchId", string | null]>
): Promise<ISearchIdMetadata> => {
  const [, searchId] = queryContext.queryKey;
  return await fetchSearchIdMetadata(searchId);
};

export const fetchSearchIdMetadata = async (
  searchId: string | null
): Promise<ISearchIdMetadata> => {
  return await (
    await axios.get(`${DATA_URL}/mosaic/${searchId}/info`, {
      params: { "api-version": API_VERSION },
    })
  ).data;
};
